import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import { AuthenticationGuard as AuthGuard } from '@app/shared/services/authguards';
import { UserGroupMappingAddEditComponent, UserGroupMappingListComponent, UserGroupMappingViewComponent } from '@user-components/user-group-mapping';

const routes: Routes = [
  { path: '', component: UserGroupMappingListComponent, canActivate: [AuthGuard], data: { title: 'Group List' } },
  { path: 'add-edit', component: UserGroupMappingAddEditComponent, canActivate: [AuthGuard], data: { title: 'Group Add/Edit' } },
  { path: 'view', component: UserGroupMappingViewComponent, canActivate: [AuthGuard], data: { title: 'View Group' } }
];
@NgModule({
  declarations: [UserGroupMappingAddEditComponent, UserGroupMappingViewComponent, UserGroupMappingListComponent],
  imports: [
    MaterialModule, SharedModule, LayoutModule, RouterModule.forChild(routes),
  ]
})
export class UserGroupMappingModule { }
